// Mock data for Froma Web Landing Page

export const services = [
  {
    id: 1,
    title: "Shopify Dropshipping Store",
    price: "₹2,499",
    priceValue: 2499,
    description: "Complete dropshipping store setup with winning products, payment integration, and order management.",
    features: [
      "Professional Shopify store setup",
      "10-15 winning products added",
      "Payment gateway integration (Razorpay/PayPal)",
      "Order tracking & fulfillment setup",
      "Mobile responsive design",
      "Basic SEO optimization",
      "Social media integration",
      "7 days post-launch support"
    ],
    featured: false
  },
  {
    id: 2,
    title: "Meta Ads Management",
    price: "₹4,999",
    priceValue: 4999,
    priceNote: "per month",
    description: "Professional Facebook & Instagram ads management to get quality leads and customers for your business.",
    features: [
      "Facebook & Instagram ad campaigns",
      "Targeted audience research & setup",
      "3-5 professional ad creatives",
      "Daily campaign monitoring",
      "A/B testing for best results",
      "Budget optimization (minimum ₹5,000 ad spend)",
      "Weekly performance reports",
      "Lead/sales tracking setup",
      "WhatsApp/Direct message integration"
    ],
    featured: true
  },
  {
    id: 3,
    title: "E-commerce Website",
    price: "₹4,999",
    priceValue: 4999,
    description: "Custom e-commerce website with shopping cart, payment integration, and complete inventory management.",
    features: [
      "Custom responsive website design",
      "Unlimited product listings",
      "Shopping cart & checkout",
      "Payment gateway integration",
      "Inventory management system",
      "Order management dashboard",
      "Customer account system",
      "SEO optimized pages",
      "Mobile-first design",
      "30 days free support"
    ],
    featured: false
  },
  {
    id: 4,
    title: "Business Website",
    price: "₹4,999",
    priceValue: 4999,
    description: "Professional business website to showcase your services, build credibility, and generate quality leads.",
    features: [
      "5-7 page professional website",
      "Custom responsive design",
      "Lead generation contact forms",
      "WhatsApp chat integration",
      "Google Maps integration",
      "Image gallery/portfolio section",
      "SEO optimized content",
      "Fast loading (under 3 seconds)",
      "Mobile-friendly design",
      "30 days free support"
    ],
    featured: false
  }
];

export const reviews = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    review: "Froma Web created an amazing Shopify store for my dropshipping business. Sales started within the first week!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    review: "Their Meta Ads service is outstanding. Got 50+ quality leads in the first month. Highly recommended!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "Amit Patel",
    rating: 5,
    review: "Professional team! They built my e-commerce website exactly as I wanted. Great support and communication.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  },
  {
    id: 4,
    name: "Neha Gupta",
    rating: 5,
    review: "Best decision for my business! The website design is modern and mobile-friendly. Thank you Froma Web!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 5,
    name: "Vikram Singh",
    rating: 5,
    review: "Affordable pricing and excellent service. They delivered my business website on time with all features I needed.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  }
];

export const contactInfo = {
  phone: "9310085929",
  email: "fromaweb@gmail.com",
  address: "Vishnu Garden, Rajendra Park, Gurugram, Haryana, India – 122001",
  whatsapp: "9310085929"
};

export const stats = {
  projectsCompleted: "100+",
  happyClients: "50+",
  yearsExperience: "5+"
};

export const whyChooseUs = [
  {
    id: 1,
    title: "Affordable Pricing",
    description: "High-quality services at prices designed for small businesses and startups",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Fast Delivery",
    description: "Quick turnaround time to get your business online and generating leads fast",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Expert Team",
    description: "5+ years of experience in web development and digital marketing",
    icon: "Users"
  },
  {
    id: 4,
    title: "24/7 Support",
    description: "Always available on WhatsApp to answer your questions and provide support",
    icon: "Headphones"
  },
  {
    id: 5,
    title: "Proven Results",
    description: "100+ successful projects and 50+ happy clients across India",
    icon: "TrendingUp"
  },
  {
    id: 6,
    title: "Mobile-First Design",
    description: "All websites are optimized for mobile devices where most customers browse",
    icon: "Smartphone"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Free Consultation",
    description: "Share your business requirements and goals with us via WhatsApp or call",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Planning & Design",
    description: "We create a custom plan and design mockup based on your needs",
    icon: "Layout"
  },
  {
    id: 3,
    title: "Development",
    description: "Our team builds your website or sets up your ad campaigns professionally",
    icon: "Code"
  },
  {
    id: 4,
    title: "Review & Launch",
    description: "You review the work, we make revisions, and then launch your project live",
    icon: "Rocket"
  }
];
